import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes';
import Middleware from '@/router/middleware/index';
import { useAuthContext } from '@/context/AuthContext';

const ForcePasswordResetCheck: FC = () => {
  const { session, isLoading } = useAuthContext();

  const canAccess = !session?.user?.user_metadata?.forceResetPassword;

  return (
    <Middleware isLoading={isLoading}>
      {canAccess ? <Outlet /> : <Navigate to={Routes.RESET_PASSWORD} />}
    </Middleware>
  );
};

export default ForcePasswordResetCheck;
